import React, {useState, useEffect} from 'react';
import $ from 'jquery';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Dialog, {DialogActions, DialogContent, DialogContentText, DialogTitle,} from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import AddIcon from 'material-ui-icons/Add';
import {NotificationManager} from 'react-notifications';
import {urlPrefix, get, post, postForm} from 'engine/dataServices';
import jMoment from 'moment-jalaali';
import ContainerHeader from 'components/ContainerHeader/index';
import InfoCard from 'components/InfoCard';
import ApallShareImage from 'assets/Images/SwiftImageIcons/Colored/1x/Shakinghands.png';
import ToDayCountImage from 'assets/Images/SwiftImageIcons/Colored/1x/Mobilepay.png';
import TotalCountImage from 'assets/Images/SwiftImageIcons/Colored/1x/Mastercard.png';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/Menu/MenuItem';
import {Link, Element, Events, animateScroll as scroll, scrollSpy, scroller} from 'react-scroll'
import {useDropzone} from 'react-dropzone';
import {Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText} from 'reactstrap';
import * as userManage from "../../../../engine/userManagements";
import Loading from 'app/loading';
import Validator from 'components/Validator';
import {getUserRoles} from 'engine/userManagements';
import Num2persian from 'num2persian';
import imageCompression from 'browser-image-compression';

const headTitles = {
    borderBottom: 1,
    borderColor: 'gray',
    borderBottomStyle: 'solid',
    paddingBottom: 5,
    marginTop: 30,
    marginBottom: 20
}

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};


const imageThumb = {
    display: 'flex',
    width: 130,
    height: 130,
    borderRadius: 2,
    border: '1px solid #eaeaea',
    padding: 4,
    boxSizing: 'border-box'
};


const compressOptions = {
    maxSizeMB: 0.3,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 1920,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10,       // optional, max number of iteration to compress the image (default: 10)
    //onProgress: Function,       // optional, a function takes one progress argument (percentage from 0 to 100)
}

function Dropzone(props) {
    const [files, setFiles] = useState([]);
    const {getRootProps, getInputProps} = useDropzone({
        accept: ['image/jpg', 'image/jpeg'],
        /*minSize : 0,
        maxSize: 20000,*/
        onDrop: items => {
            const maxUploadSize = 18000000;
            let acceptedFiles = [];
            let previews = [];
            items.map(async (item) => {
                //حجم هر تصویر می بایست از 50 کیلوبایت کم تر باشد.
                if (item.size <= maxUploadSize) {
                    previews.push(item);
                    let compressedImage = await imageCompression(item, compressOptions);
                    acceptedFiles.push(compressedImage);
                } else
                    NotificationManager.error(`حداکثر مجاز برای حجم هر تصویر
                    ${maxUploadSize / 1000} 
                     کیلوبایت می باشد. حجم تصویر با نام
                     ${item.name}
                     بیش از مقدار مورد قبول می باشد.`
                        , 'خطای کاربری');

            })


            setFiles(previews.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));

            if (items.length > 0) {
                this.setState({uploadFiles: acceptedFiles});
            }
        },
        onDropRejected: () => NotificationManager.error('فرمت فایل قابل قبول تنها از نوع Jpg می باشد.', 'خطا')
})
    ;

    const thumbs = files.map(file => {
        return (
            <div style={thumb} key={file.name}>
                <div style={thumbInner}>
                    <img
                        src={file.preview}
                        style={img}
                    />
                </div>
            </div>
        );
    });

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    return (
        <section style={{display: 'flex', flexDirection: 'column', marginRight: 50, marginLeft: 50}}>
            <div {...getRootProps({className: 'dropzone'})} style={{
                flex: 1,
                flexDirection: 'column',
                alignItems: 'center',
                padding: 20,
                backgroundColor: '#fafafa',
                color: '#bdbdbd',
                borderStyle: 'dashed',
                borderRadius: 2,
                borderColor: '#eeeeee',
                borderWidth: 2,
                justifyContent: 'center',
                textAlign: 'center'
            }}>
                <input {...getInputProps()} />
                <p>جهت بارگزاری تصاویر محصولات خود تصویر مورد نظر را به اینجا Drag & Drop نموده و یا در این ناحیه کلیک
                    نمایید.</p>
                <aside style={thumbsContainer}>
                    {thumbs}
                </aside>
            </div>
        </section>
    );
}

class DataTableHead extends React.Component {

    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        //onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {//onSelectAllClick,
            data, order, orderBy, rowCount
        } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {data.map(column => {
                        const visibility = (column.hidden) ? {display: 'none'} : {display: 'table-cell'};

                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                                className='text-center'
                                style={visibility}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

let DataTableToolbar = props => {

    return (
        <Toolbar
            className={classNames("table-header")}
        >

            <div className="title">
                <Typography type="title"></Typography>
            </div>
            <div className="spacer"/>
            <div className="actions">
            </div>
        </Toolbar>
    );
};

let ImageThumbs = props => {
    let parent = props.props;
    let {images} = parent.state;


    async function deleteImageBtn(imageId) {
        parent.handleLoading(true);


        let res = await post(`Product/DeleteProductImage?id=${imageId}`);
        if (res.status === 200)
            await props.props.loadProductDetailToEdit(props.props.state.id);

        parent.handleLoading(false);
    }

    async function setPrimaryImageBtn(imageId) {
        parent.handleLoading(true);

        let res = await post(`Product/SetPrimaryProductImage?id=${imageId}`);
        if (res.status === 200) {
            await props.props.loadProductDetailToEdit(props.props.state.id);
        }

        parent.handleLoading(false);
    }

    const thumbs = images.map(file => {
        return (
            <div style={{display: 'inline-flex', flexDirection: 'column', marginRight: 15}}>
                <div style={imageThumb} key={file.Id}>
                    <div style={{top: -15, right: -15, position: 'relative'}}>
                        {(!file.IsPrimary) ?
                            <Button variant="fab" className="bg-red darken-2 text-white"
                                    title="حذف تصویر از آرشیو تصاویر محصول"
                                    onClick={deleteImageBtn.bind(this, file.Id)}
                                    style={{position: 'absolute', height: 30, width: 35}}>
                                <i className="zmdi zmdi-close zmdi-hc-fw" style={{fontSize: 18, fontWeight: 'bold'}}/>
                            </Button>
                            :
                            <i className="zmdi zmdi-check zmdi-hc-fw" title="تصویر پیش فرض"
                               style={{fontSize: 32, fontWeight: 'bold', color: 'green', position: 'absolute'}}/>
                        }
                    </div>
                    <div style={thumbInner}>
                        <img
                            src={urlPrefix + file.Image}
                            style={img}
                        />
                    </div>
                </div>
                <div style={{flex: 1, textAlign: 'center', marginTop: 5}}>
                    {!file.IsPrimary &&
                    <Chip style={{backgroundColor: '#4caf50', color: 'white'}}
                          title="انتخاب این تصویر به عنوان تصویر پیش فرض محصول"
                          onClick={setPrimaryImageBtn.bind(this, file.Id)}
                          avatar={
                              <Avatar style={{backgroundColor: 'green', color: 'white'}}>
                                  <i className="zmdi zmdi-check zmdi-hc-fw" style={{fontSize: 18, fontWeight: 'bold'}}/>
                              </Avatar>
                          }
                          label="پیش فرض"
                    />
                    }
                </div>
            </div>
        )
    });

    return (
        <div style={{marginBottom: 30, marginTop: 20}}>{thumbs}</div>
    );
}

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)   // General scroll to element function


class Products extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.myRef = React.createRef();

        const userRoles = getUserRoles();
        const _isSuperUser = userRoles.includes('SuperUsers');

        this.state = {
            id: '',
            name: '',
            price: '',
            stock: '',
            category: 0,
            uploadFiles: [],
            images: [],
            properties: [],
            description: '',
            categories: [],
            txtFunctionType: '',
            showEditContainer: false,
            order: 'asc',
            orderBy: 'calories',
            selected: 0,
            data: [],
            page: 0,
            rowsPerPage: 5,
            showDeleteDialog: false,
            deleteReason: '',
            loading: true,
            isSuperUser: _isSuperUser
        };

        this.validator = Validator();

        Dropzone = Dropzone.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({data, order, orderBy});
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, id) => {
        this.setState({selected: id});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    isSelected = id => this.state.selected === id;

    async loadData() {
        this.setState({showEditContainer: false, functionType: ''});

        const response = await get('Product/Get');
        if (response.status === 200) {
            var _data = await response.json();
            this.setState({
                data: _data
            })
        }
        this.handleLoading(false);
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleChange_dynamicFileds = id => event => {
        let obj = this.state.properties;
        let index = obj.findIndex(x => x.Id == id)
        obj[index].Value = event.target.value;
        this.setState({
            properties: obj
        });
    };

    categoryHandleChange = async (event) => {
        let categoryId = event.target.value;
        this.setState({category: categoryId});
        await this.loadProperties(categoryId);
    }

    loadProperties = async (categoryId) => {
        let responseResult = await get('Property/GetProperties?categoryId=' + categoryId);
        var properties = await responseResult.json();
        this.setState({properties: properties});
    }

    loadCategories = async () => {
        let response = await get('Category/GetAll_Names');
        if (response.status === 200) {
            let _data = await response.json();
            if (_data.length > 0)
                this.setState({categories: _data, category: _data[0].Id});
        }
    }

    AddOrEditBtn = async (functionType, item) => {
        if (functionType) {
            this.handleLoading(true);
            this.cleanForm();
            this.setState({showEditContainer: true, functionType: functionType});

            switch (functionType) {
                case 'Add':
                    this.setState({txtFunctionType: 'افزودن محصول'});
                    await this.loadCategories();
                    await this.loadProperties(this.state.category);
                    break;
                case 'Edit':
                    this.setState({txtFunctionType: 'ویرایش محصول'});
                    await this.loadCategories();
                    await this.loadProductDetailToEdit(item.Id);
                    break;
            }
            this.handleLoading(false);
            this.scroll(this.myRef);
        }


    }

    scroll(ref) {
        ref.current.scrollIntoView({behavior: 'smooth'})
    }

    submitBtn = async () => {
        try {
            let validFields = true;
            let fields = ['قیمت', 'موجودی', 'نام محصول', 'توضیحات']
            this.state.properties.map(x => fields.push(x.Name));

            fields.map((field) => {
                if (!this.validator.fieldValid(field)) {
                    validFields = false;
                    return;
                }
            });

            if (validFields) {
                this.handleLoading(true);
                switch (this.state.functionType) {
                    case 'Add':
                        debugger;
                        if (this.state.uploadFiles.length == 0) {
                            NotificationManager.error('بارگزاری حداقل یک تصویر برای محصول الزامیست.', 'خطا');
                            break;
                        }
                        await this.addProduct();
                        break;
                    case 'Edit':
                        await this.updateProduct();
                        break;
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        } finally {
            this.handleLoading(false)
        }

    }

    addProduct = async () => {
        let {name, price, stock, category, properties, uploadFiles, description} = this.state;
        let form = new FormData();
        for (var index = 0; index < uploadFiles.length; index++) {
            var element = uploadFiles[index];
            form.append('Images', element);
        }

        form.append('name', name);
        form.append('price', price);
        form.append('stock', stock);
        form.append('Category', JSON.stringify({Id: category}));
        form.append('Description', description);
        form.append('Properties', JSON.stringify(properties));

        var response = await postForm('Product/Create', form);
        switch (response.status) {
            case 200:
                NotificationManager.success(`محصول ${name} با موفقیت در تولیتون ثبت شد.`, 'عملیات موفق');
                this.loadData();
                return;
        }
        NotificationManager.error(`خطا در ثبت محصول`, 'خطا');
    }

    updateProduct = async () => {
        let editFormData = new FormData();
        let {id, name, price, stock, category, properties, uploadFiles, description} = this.state;
        for (var index = 0; index < uploadFiles.length; index++) {
            var element = uploadFiles[index];
            editFormData.append('Images', element);
        }
        editFormData.append('Id', id);
        editFormData.append('name', name);
        editFormData.append('price', price);
        editFormData.append('stock', stock);
        editFormData.append('Category', JSON.stringify({Id: category}));
        editFormData.append('Description', description);
        editFormData.append('Properties', JSON.stringify(properties));

        var response = await postForm('Product/Update', editFormData);
        switch (response.status) {
            case 200:
                NotificationManager.success(`محصول ${name} با موفقیت در تولیتون ویرایش شد.`, 'عملیات موفق');
                this.loadData();
                return;
        }
        NotificationManager.error(`خطا در ثبت محصول`, 'خطا');
    }

    closeEditContainer = () => {
        this.setState({showEditContainer: false});
        //this.cleanForm();
    }

    cleanForm = () => {
        this.setState({
            id: '',
            name: '',
            price: '',
            stock: '',
            category: 0,
            uploadFiles: [],
            images: [],
            properties: [],
            description: ''
        });
    }

    loadProductDetailToEdit = async (productId) => {
        let response = await get(`Product/GetById?productId=${productId}`);
        if (response.status == 200) {
            let data = await response.json();
            this.setState({
                id: data.Id,
                name: data.Name,
                price: data.Price,
                stock: data.Stock,
                category: data.Category.Id,
                uploadFiles: [],
                images: data.Images,
                properties: data.Properties,
                description: data.Description
            })
        }
    };

    handleDeleteBtn = async () => {
        if (this.validator.fieldValid('علت')) {
            this.handleLoading(true);
            const {selected, deleteReason} = this.state;

            const userRoles = getUserRoles();
            const isSuperUser = userRoles.includes('SuperUsers');

            let response;
            if (isSuperUser)
                response = await post(`Product/AdminDelete?id=${selected}&reason=${deleteReason}`);
            else
                response = await post(`Product/Delete?id=${selected}&reason=${deleteReason}`);

            if (response) {
                if (response.status == 200) {
                    this.setState({showDeleteDialog: false});
                    NotificationManager.success(' عملیات حذف محصول با موفقیت انجام شد.', 'عملیات موفق');
                    this.loadData();
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        }
        this.handleLoading(false);
    }

    handleOpenDeleteModal = async () => {
        this.setState({showDeleteDialog: true, deleteReason: ''});
    }

    handleCloseDeleteModal = async () => {
        this.setState({showDeleteDialog: false});
    }

    render() {
        const {data, order, orderBy, selected, rowsPerPage, page, isSuperUser} = this.state;
        const {properties, category, categories, images, price, stock} = this.state;

        let columnData = [
            {id: 'Image', numeric: false, disablePadding: true, label: 'تصویر'},
            {id: 'Id', numeric: false, visible: false, disablePadding: true, label: 'شناسه'},
            {id: 'Name', numeric: false, disablePadding: true, label: 'نام'},
            {id: 'CategoryName', numeric: false, disablePadding: true, label: 'دسته بندی'},
            {id: 'ProducerName', numeric: false, disablePadding: true, label: 'نام فروشنده', hidden: (!isSuperUser)},
            {id: 'Price', numeric: false, disablePadding: true, label: 'قیمت (تومان)'},
            {id: 'Stock', numeric: false, disablePadding: true, label: 'موجودی'},
            {id: 'CreatedDate', numeric: false, disablePadding: true, label: 'تاریخ ایجاد'},
            {id: 'ModifiedDate', numeric: false, disablePadding: true, label: 'تاریخ آخرین ویرایش'},
        ];


        return (
            <div>
                {this.state.loading && <Loading/>}

                <ContainerHeader match={this.props.match} title="مدیریت محصولات"/>

                <Paper>
                    {/*<DataTableToolbar/>*/}

                    <div style={{paddingTop: 15}}>
                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                style={{marginRight: 10}} onClick={this.AddOrEditBtn.bind(this, "Add")}>
                            <i className="zmdi zmdi-plus zmdi-hc-fw"/>
                            <span>افزودن</span>
                        </Button>
                    </div>

                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table className="">
                                <DataTableHead
                                    data={columnData}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.Id);
                                        return (
                                            <TableRow
                                                hover
                                                onClick={event => this.handleClick(event, n.Id)}
                                                onKeyDown={event => this.handleKeyDown(event, n.Id)}
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.Id}
                                                selected={isSelected}
                                            >
                                                <TableCell padding="none"
                                                           className="text-center">{n.Images.length > 0 && (
                                                    <img src={urlPrefix + n.Images[0].Image}
                                                         style={{
                                                             height: 70,
                                                             width: 100,
                                                             borderRadius: 10,
                                                             marginTop: 5,
                                                             marginBottom: 5,
                                                             objectFit: 'cover'
                                                         }}/>
                                                )}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Id}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Name}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Category.Name}</TableCell>
                                                {isSuperUser &&
                                                <TableCell padding="none"
                                                           className="text-center">{n.Producer.Name}</TableCell>
                                                }
                                                <TableCell padding="none"
                                                           className="text-center">{n.Price.toLocaleString()}</TableCell>
                                                <TableCell padding="none"
                                                           className="text-center">{n.Stock.toLocaleString()}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{jMoment(n.CreatedDate).format('HH:mm - jYYYY/jMM/jDD')}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">{(n.ModifiedDate) ? jMoment(n.ModifiedDate).format('HH:mm - jYYYY/jMM/jDD') : 'در انتظار تایید...'}</TableCell>
                                                <TableCell
                                                    padding="none"
                                                    className="text-center">
                                                    <Button variant="raised"
                                                            className="jr-btn bg-cyan jr-btn-sm text-white"
                                                            style={{marginRight: 10}}
                                                            onClick={this.AddOrEditBtn.bind(this, "Edit", n)}>
                                                        <i className="zmdi zmdi-edit zmdi-hc-fw"/>
                                                        <span>ویرایش</span>
                                                    </Button>
                                                    <Button variant="raised"
                                                            onClick={this.handleOpenDeleteModal.bind(this)}
                                                            className="jr-btn bg-red jr-btn-sm text-white"
                                                            style={{marginRight: 10}}>
                                                        <i className="zmdi zmdi-delete zmdi-hc-fw"/>
                                                        <span>حذف</span>
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>
                <div id="editContainer" ref={this.myRef} style={{paddingTop: 5}}>
                    {this.state.showEditContainer && (
                        <section>
                            <Card className={`shadow border-0`} style={{marginTop: 25}}>
                                <CardHeader className="bg-primary text-white">{this.state.txtFunctionType}</CardHeader>
                                <CardBody>
                                    <form className="row" noValidate autoComplete="off">
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="name"
                                                label="نام محصول"
                                                value={this.state.name}
                                                onChange={this.handleChange('name')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('نام محصول', this.state.name, 'required')}
                                        </div>
                                        <div className="col-md-3 col-12">
                                            {/*We can user auto complete component here*/}
                                            <TextField
                                                id="category"
                                                select
                                                label="دسته بندی محصول"
                                                value={category}
                                                onChange={this.categoryHandleChange}
                                                SelectProps={{}}
                                                margin="normal"
                                                fullWidth
                                                disabled={this.state.functionType === "Edit"}
                                            >
                                                {categories.map(option => (
                                                    <MenuItem key={option.Id} value={option.Id}>
                                                        {option.Name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="price"
                                                label="قیمت (تومان)"
                                                value={price}
                                                onChange={this.handleChange('price')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {price && <span style={{color: 'green'}}>{Num2persian(price)} تومان</span>}
                                            {this.validator.message('قیمت', price, 'required|integer')}
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            {/*TODO: باید اینجا موجودی انبار هم محاسبه و نمایش داده شود*/}
                                            <TextField
                                                id="stock"
                                                label="موجودی"
                                                value={stock}
                                                onChange={this.handleChange('stock')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('موجودی', stock, 'required|integer')}
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <h2 className="col-lg-3 col-md-3 col-12" style={headTitles}>بارگزاری تصویر
                                                محصول</h2>
                                        </div>
                                        <div className="col-12">
                                            <Dropzone props={this}/>
                                        </div>
                                        {images.length > 0 &&
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <h2 className="col-lg-3 col-md-3 col-12" style={headTitles}>
                                                تصاویر بارگزاری شده
                                            </h2>
                                        </div>
                                        }
                                        <div className="col-12">
                                            <ImageThumbs props={this}/>
                                        </div>
                                        <div className="col-12">
                                            <TextField
                                                id="multiline-flexible"
                                                label="توضیحات"
                                                multiline
                                                rowsMax="4"
                                                rows="3"
                                                value={this.state.description}
                                                onChange={this.handleChange('description')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('توضیحات', this.state.description, 'required')}
                                        </div>
                                        {properties.length > 0 &&
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <h2 className="col-lg-3 col-md-3 col-12" style={headTitles}>آیتم های
                                                پویا</h2>
                                        </div>
                                        }
                                        {properties.map(item => {
                                            return (
                                                <div className="col-lg-3 col-md-3 col-12">
                                                    <TextField
                                                        id={item.Id}
                                                        label={item.Name}
                                                        value={item.Value ? item.Value : ''}
                                                        onChange={this.handleChange_dynamicFileds(item.Id)}
                                                        margin="normal"
                                                        fullWidth
                                                    />
                                                    {this.validator.message(item.Name, item.Value, 'required')}
                                                </div>
                                            );
                                        })}
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <div style={{textAlign: 'left'}}>
                                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.submitBtn}>
                                            <i className="zmdi zmdi-check zmdi-hc-fw"/>
                                            <span>ثبت</span>
                                        </Button>
                                        <Button variant="raised" className="jr-btn bg-red jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.closeEditContainer}>
                                            <i className="zmdi zmdi-close zmdi-hc-fw"/>
                                            <span>انصراف</span>
                                        </Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </section>
                    )}
                </div>
                    <Dialog open={this.state.showDeleteDialog} onClose={this.handleCloseDeleteModal.bind(this)}>
                    <DialogTitle>تایید</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            علت حذف محصول را وارد نمایید.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="علت حذف محصول"
                            value={this.state.deleteReason}
                            onChange={this.handleChange('deleteReason')}
                            fullWidth
                        />
                        {this.validator.message('علت', this.state.deleteReason, 'required|min:5')}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseDeleteModal.bind(this)} color="secondary">
                            لغو
                        </Button>
                        <Button onClick={this.handleDeleteBtn.bind(this)} color="primary">
                            تایید
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        );

    }
}

export default Products;



// WEBPACK FOOTER //
// ./app/routes/toliton/products/products.js